import { useEffect } from "react";

/**
 * Lightweight SEO hook — sets document.title and injects meta tags without react-helmet.
 * Also injects JSON-LD schema when provided.
 */
export function useSEO({ title, description, canonical, image, ogType = "website", jsonLd } = {}) {
    useEffect(() => {
        if (title) document.title = title;

        const setMeta = (attr, key, content) => {
            if (!content) return;
            let el = document.head.querySelector(`meta[${attr}="${key}"]`);
            if (!el) {
                el = document.createElement("meta");
                el.setAttribute(attr, key);
                document.head.appendChild(el);
            }
            el.setAttribute("content", content);
        };

        setMeta("name", "description", description);
        setMeta("property", "og:title", title);
        setMeta("property", "og:description", description);
        setMeta("property", "og:type", ogType);
        setMeta("property", "og:image", image);
        setMeta("name", "twitter:card", "summary_large_image");
        setMeta("name", "twitter:title", title);
        setMeta("name", "twitter:description", description);

        if (canonical) {
            let link = document.head.querySelector('link[rel="canonical"]');
            if (!link) {
                link = document.createElement("link");
                link.setAttribute("rel", "canonical");
                document.head.appendChild(link);
            }
            link.setAttribute("href", canonical);
        }

        // JSON-LD
        const existing = document.head.querySelector('script[data-testid="jsonld-page"]');
        if (existing) existing.remove();
        if (jsonLd) {
            const s = document.createElement("script");
            s.type = "application/ld+json";
            s.setAttribute("data-testid", "jsonld-page");
            s.text = JSON.stringify(jsonLd);
            document.head.appendChild(s);
        }
    }, [title, description, canonical, image, ogType, jsonLd]);
}

export function orgSchema() {
    return {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "RKS Systems",
        url: typeof window !== "undefined" ? window.location.origin : "https://rkssystems.com",
        logo: "https://customer-assets.emergentagent.com/job_rks-elegant-site/artifacts/hcnjzq8m_Screenshot%202026-05-27%20150113.png",
        sameAs: [],
        description: "RKS Systems is a strategic offshore technology partner delivering product engineering, cloud, data and AI outcomes to US and global enterprises.",
        contactPoint: [{
            "@type": "ContactPoint",
            contactType: "sales",
            email: "info@rkssystems.com",
            telephone: "+91-83095-75095",
            areaServed: "Worldwide",
        }],
        address: {
            "@type": "PostalAddress",
            streetAddress: "Building 9, Mindspace, Madhapur",
            addressLocality: "Hyderabad",
            postalCode: "500081",
            addressCountry: "IN",
        },
    };
}
